import FormBlock from "./FormBlock";
import FormInput from "./FormInput";
import FileInput from "./FileInput";
const Form = { Block: FormBlock, Input: FormInput, File: FileInput };
export default Form;
